import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { PromoBanner } from './PromoBanner';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen bg-cream font-body selection:bg-brand-gold selection:text-near-black flex flex-col" data-id="element-299">
      <PromoBanner data-id="element-300" />
      <Navbar data-id="element-301" />
      <main className="flex-grow" data-id="element-302">
        <Outlet data-id="element-303" />
      </main>
      <Footer data-id="element-304" />
    </div>;
}